import { render, staticRenderFns } from "./SchemaConfiguration.vue?vue&type=template&id=c9438006"
import script from "./SchemaConfiguration.vue?vue&type=script&lang=js"
export * from "./SchemaConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports